<template>
    <div class="course-orders-calendar">


        <div class="mb-3 row">
            <div class="col-md-9">

                <div class="form-check float-left text-nowrap ml-4 mb-2 mt-3 mb-md-0 mb-mt-0" v-for="guest in guests">
                    <input type="checkbox" class="form-check-input" :id="'guestCheck' + guest.id"
                           v-model="selectedGuestsIds"
                           :style="{ outline: '2px solid' + guest.color }" :value="guest.id">
                    <label class="form-check-label font-size-up font-weight-slightly-bold"
                           :for="'guestCheck' + guest.id"
                           :style="{ color: guest.color }"> {{ guest.name }}</label>
                </div>

            </div>
            <div class="col-md-3">
                <div class="my-2 my-md-0">
                    <select class="form-control form-control-lg form-select-borderless" v-model="viewMode"
                            @change="updateView">
                        <option value="">all days</option>
                        <option :value="date.format('YYYY-M-D')" v-for="date in allAvailableDates">
                            {{ date.format('dddd, MMM D') }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="clearfix"></div>

        <div class="d-flex flex-row flex-nowrap align-content-stretch"
             v-if="dates.length > 0 && hours.length > 0 && calendar">
            <div class="hours flex-shrink-1">
                <div class="hour" v-for="hour in hours">
                    {{ hour }}:00
                </div>
            </div>
            <div class="day flex-grow-1" v-for="day in dates">
                <div class="label d-none">{{ getCalendarDateName(day) }}</div>
                <div class="hour" v-for="hour in hours"
                     :class="{'unavailable': !canCreateCourseOrder(day, hour, true)}">
                    <div v-if="calendar[day.format('YYYY-M-D')] && calendar[day.format('YYYY-M-D')][hour]"
                         class="schedule-wrap">
                        <div class="schedule-card d-flex flex-row align-items-stretch"
                             :class="{'card-wait': card.type === 'wait', 'card-book4time': card.type === 'book4time', 'card-checkin': card.type === 'book4time-checkin', 'card-transportation': card.type === 'transportation'}"
                             v-for="card in calendar[day.format('YYYY-M-D')][hour]"
                             :style="cardDimensions(card)" @click="showScheduleDetails(card)">

                            <div class="card-users d-flex flex-column align-items-stretch">
                                <div class="user flex-fill" :style="{ backgroundColor: guest.user.color }"
                                     v-for="guest in card.guests" :title="guest.user.name">
                                    <span>#{{ guest.user.id }}</span>
                                </div>
                            </div>
                            <div class="card-course d-flex flex-column align-items-stretch flex-fill">
                                <div class="course flex-fill" v-if="card.type  === 'book4time-checkin'">
                                    <div class="">
                                        {{ card.service_name }}
                                    </div>
                                </div>
                                <div class="course flex-fill" v-if="card.type  === 'book4time'">
                                    <div class="name">
                                        <a href="#" @click.prevent="showScheduleDetails(card)">{{
                                                card.service_name
                                            }}</a>
                                    </div>
                                    <div class="trainer">
                                        <span class="small text-muted"></span>
                                        <div class="row">
                                            <div class="col-6"><span
                                                v-if="card.service_group_name">{{ card.service_group_name }}</span>
                                            </div>
                                            <div class="col-6"><span v-if="card.status !== 'Confirmed'"
                                                                     class="float-right text-danger small">[{{
                                                    card.status
                                                }}]</span></div>
                                        </div>
                                        <a href="#" style="display: none;"
                                           @click.prevent="showScheduleDetails(card)">{{ card.technician_name }}</a>
                                    </div>
                                </div>
                                <div class="course flex-fill" v-else-if="card.type  === 'transportation'">
                                    <div class="name">
                                        <a href="#">{{
                                                card.service_name
                                            }}</a>
                                    </div>
                                    <div class="trainer">
                                        <span class="small text-muted"></span>
                                        <div class="row">
                                            <div class="col-12"><span
                                                v-if="card.service_group_name" v-html="nl2br(card.service_group_name)"></span>
                                            </div>
                                        </div>
                                        <a href="#" style="display: none;"
                                           @click.prevent="showScheduleDetails(card)">{{ card.technician_name }}</a>
                                    </div>
                                </div>
                                <div class="course flex-fill" v-else>
                                    <div class="name"><a :href="card.link" target="_blank"
                                                         @click.prevent="showScheduleDetails(card)"
                                                         :title="card.course.name">{{ card.course.name }}</a>
                                        <span v-if="card.type === 'wait'" class="small text-muted">[wait]</span>
                                    </div>
                                    <div class="trainer"><a :href="card.trainer.link"
                                                            @click.prevent="showScheduleDetails(card)"
                                                            target="_blank">{{ card.trainer.name }}</a></div>
                                </div>
                                <div class="schedule" @click="showScheduleDetails(card)"
                                     v-if="card.type  !== 'book4time-checkin'">
                                    <i class="far fa-calendar-alt float-right"></i>
                                    {{ card.from | dateFormat('h:mm a') }} - {{ card.till | dateFormat('h:mm a') }}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div v-if="canCreateCourseOrder(day, hour, true)"
                         class="schedule-placement">
                        <div class="add-order" @click="newCourseOrder(day, hour)">
                            Show available courses for this time slot
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>


</template>


<script>

export default {
    props: {
        booking: Object,
        selectedDate: String
    },
    data() {
        return {
            selectedGuestsIds: [],
            viewMode: '',
            dates: [],
            allAvailableDates: [],
            hours: [],
            calendar: {},
            courseOrders: [],
            courseWaits: [],
            book4timeOrders: [],
            guests: [],
            calendarLoading: {},
            windowWidth: 0,
            courseScheduleTimeSlots: {}
        };
    },
    mounted() {
        this.prepareCalendar();
        this.windowWidth = window.innerWidth;
        if (this.selectedDate) {
            this.viewMode = this.selectedDate
        }
        this.switchToPerDayView();
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
            //this.switchToPerDayView();
        })
    },
    watch: {
        selectedGuestsIds: {
            handler: function (val, oldVal) {
                this.updateCalendar();
                this.$emit('user-list-changed', {user_ids: val})
            }
        }
    },
    methods: {
        switchToPerDayView: function () {
            let widthPerDay = this.windowWidth / this.allAvailableDates.length;
            if (widthPerDay < 350) {
                let today = moment();
                today.set("hour", 0).set("minute", 0).set("second", 0).set("millisecond", 0);
                let todaySelected = _.find(this.allAvailableDates, function (d) {
                    return today.isSame(d);
                })
                // _(this.allAvailableDates).each((d) => console.log(d.format('YYYY-M-D HH:mm:ss')));
                // console.log(todaySelected);
                if (todaySelected) {
                    this.viewMode = todaySelected.format('YYYY-M-D');
                    this.updateView();
                } else {
                    let futureDate = _.find(this.allAvailableDates, function (d) {
                        return d.isAfter(today);
                    })
                    if (futureDate) {
                        this.viewMode = futureDate.format('YYYY-M-D');
                        this.updateView();
                    } else {
                        let lastDate = _.last(this.allAvailableDates);
                        if (lastDate) {
                            this.viewMode = lastDate.format('YYYY-M-D');
                            this.updateView();
                        }
                    }
                }
            }
        },
        prepareCalendar: function () {
            this.courseOrders = _.clone(this.booking.orders);
            this.courseWaits = _.clone(this.booking.waits);
            this.book4timeOrders = _.clone(this.booking.book4times);
            this.getAllDatesFromBooking();
            this.getGuestsFromBooking();
            this.buildCalendar();
        },
        canCreateCourseOrder: function (day, hour, allowEdit) {
            let dayWithHour = day.clone();
            dayWithHour.hour(hour).minutes(0).seconds(0).milliseconds(0);
            if (dayWithHour.isBefore()) {
                return false;
            }
            if (!this.calendarLoading[day.format('YYYY-M-D')]) {
                return true;
            }
            if (!this.calendarLoading[day.format('YYYY-M-D')][hour]) {
                return true;
            }

            if (allowEdit) {
                return true; // force allow to edit
            }

            return false;
        },
        updateCalendar: function () {
            if (this.calendar) {
                let orders = _.clone(this.booking.orders);
                let selectedGuestIds = this.selectedGuestsIds;
                orders = _.filter(orders, function (v) {
                    return _.indexOf(selectedGuestIds, v.user_id) !== -1;
                })
                this.courseOrders = orders;
                let waits = _.clone(this.booking.waits);
                waits = _.filter(waits, function (v) {
                    return _.indexOf(selectedGuestIds, v.user_id) !== -1;
                })
                this.courseWaits = waits;

                let book4times = _.clone(this.booking.book4times);
                book4times = _.filter(book4times, function (v) {
                    return _.indexOf(selectedGuestIds, v.user_id) !== -1;
                })
                this.book4timeOrders = book4times;

                this.buildCalendar();
            }
        },
        buildCalendar: function () {
            this.getHoursRangeFromOrders();
            this.buildScheduleCards();
        },
        getGuestsFromBooking: function () {
            this.guests = [];
            this.selectedGuestsIds = [];
            for (let i = 0; i < this.booking.guests.length; i++) {
                let g = this.booking.guests[i];
                if (_.isUndefined(g.color)) {
                    g.color = this.makeColorForGuest(g);
                }
                this.guests.push(g);
                this.selectedGuestsIds.push(g.id);
            }
        },
        makeColorForGuest: function (guest) {
            let name = guest.name + guest.email + guest.id + +guest.phone;
            return stringToColour(name);
        },
        cardDimensions: function (card) {
            let height = card.dimensions.height;
            if (card.type !== 'book4time-checkin') {
                if (height < 70) {
                    height = 70;
                }
            }
            return {
                height: height + 'px',
                top: card.dimensions.top + 'px',
                width: card.dimensions.width - 0.5 + '%',
                marginLeft: card.dimensions.offset + '%'
            }
        },
        updateView: function () {
            if (this.viewMode === '') {
                this.dates = this.allAvailableDates;
            } else {
                let vm = this.viewMode;
                this.dates = _.filter(this.allAvailableDates, function (v) {
                    return v.format('YYYY-M-D') === vm;
                });
                gtag('event', 'calendar', {
                    'event_category': 'switch_date_view',
                    'booking_id': this.booking.id,
                    //'event_label': 'date_' + vm,
                    'view': vm,
                });
            }
        },
        getAllDatesFromBooking: function () {
            let from = moment(this.booking.from);
            let till = moment(this.booking.till);
            let d = from.clone();
            let dates = [];
            while (d.isSameOrBefore(till)) {
                dates.push(d.clone());
                d.add(1, 'days');
            }
            this.allAvailableDates = dates;
            if (this.dates.length === 0) {
                this.dates = dates;
            }
        },
        getHoursRangeFromOrders: function () {
            const orders = this.courseOrders;
            let hours = [];
            for (let i = 0; i < orders.length; i++) {
                let f = moment(orders[i].from).hour();
                let t = moment(orders[i].till).hour();
                hours.push(f);
                hours.push(t);
            }
            const waits = this.courseWaits;
            for (let i = 0; i < waits.length; i++) {
                let f = moment(waits[i].from).hour();
                let t = moment(waits[i].till).hour();
                hours.push(f);
                hours.push(t);
            }
            const book4times = this.book4timeOrders;
            for (let i = 0; i < book4times.length; i++) {
                let f = moment(book4times[i].from).hour();
                let t = moment(book4times[i].till).hour();
                hours.push(f);
                hours.push(t);
            }

            let maxHour = 20;
            let minHour = 7;
            if (hours.length > 1) {
                maxHour = _.max(hours) + 1;
                minHour = _.min(hours);
                if (maxHour < 20) {
                    maxHour = 20;
                }
                if (minHour > 7) {
                    minHour = 7;
                }
            }

            let newHours = [];
            for (let i = minHour; i <= maxHour; i++) {
                newHours.push(i);
            }
            this.hours = newHours;
        },
        sortCalendarLoadingByScheduleStart: function (calendarLoading) {
            let sortedCalendar = {};
            let that = this;
            _.forEach(calendarLoading, function (hours, date) {
                _.forEach(hours, function (courseSchedules, hour) {
                    if (_.isUndefined(sortedCalendar[date])) {
                        sortedCalendar[date] = {};
                    }
                    sortedCalendar[date][hour] = that.sortCourseSchedulesByStart(courseSchedules);
                });
            });

            return sortedCalendar;
        },
        sortCourseSchedulesByStart: function (courseSchedules) {
            let that = this;
            if (courseSchedules.length > 1) {
                let sortedCourseSchedules = _.sortBy(courseSchedules, function (courseScheduleId) {
                    let start = that.courseScheduleTimeSlots[courseScheduleId].start;
                    return start.format('YYYY-M-D H:m:s');
                });
                return sortedCourseSchedules;
            }

            return courseSchedules;
        },
        buildScheduleCards: function () {
            const orders = this.courseOrders;
            let calendarLoading = {};
            for (let i = 0; i < orders.length; i++) {
                let start = moment(orders[i].from);
                let end = moment(orders[i].till);
                let startDay = start.format('YYYY-M-D');
                let startHour = start.hour();
                let endHour = end.hour();
                if (end.minutes() === 0) {
                    endHour = endHour - 1;
                }
                if (_.isUndefined(calendarLoading[startDay])) {
                    calendarLoading[startDay] = {};
                }
                for (let j = startHour; j <= endHour; j++) {
                    if (_.isUndefined(calendarLoading[startDay][j])) {
                        calendarLoading[startDay][j] = [];
                    }
                    if (_.indexOf(calendarLoading[startDay][j], orders[i].course_schedule_id) === -1) {
                        calendarLoading[startDay][j].push(orders[i].course_schedule_id);
                    }
                }
                this.courseScheduleTimeSlots[orders[i].course_schedule_id] = {
                    start: start,
                    end: end,
                };
            }
            const waits = this.courseWaits;
            for (let i = 0; i < waits.length; i++) {
                let start = moment(waits[i].course_schedule.from);
                let end = moment(waits[i].course_schedule.till);
                let startDay = start.format('YYYY-M-D');
                let startHour = start.hour();
                let endHour = end.hour();
                if (end.minutes() === 0) {
                    endHour = endHour - 1;
                }
                if (_.isUndefined(calendarLoading[startDay])) {
                    calendarLoading[startDay] = {};
                }
                for (let j = startHour; j <= endHour; j++) {
                    if (_.isUndefined(calendarLoading[startDay][j])) {
                        calendarLoading[startDay][j] = [];
                    }
                    if (_.indexOf(calendarLoading[startDay][j], waits[i].course_schedule.id) === -1) {
                        calendarLoading[startDay][j].push(waits[i].course_schedule.id);
                    }
                }
                this.courseScheduleTimeSlots[waits[i].course_schedule.id] = {
                    start: start,
                    end: end,
                };
            }
            const book4times = this.book4timeOrders;
            for (let i = 0; i < book4times.length; i++) {
                let start = moment(book4times[i].from);
                let end = moment(book4times[i].till);
                let startDay = start.format('YYYY-M-D');
                let startHour = start.hour();
                let endHour = end.hour();
                if (end.minutes() === 0) {
                    endHour = endHour - 1;
                }
                if (_.isUndefined(calendarLoading[startDay])) {
                    calendarLoading[startDay] = {};
                }
                for (let j = startHour; j <= endHour; j++) {
                    if (_.isUndefined(calendarLoading[startDay][j])) {
                        calendarLoading[startDay][j] = [];
                    }
                    if (_.indexOf(calendarLoading[startDay][j], 'book4time_' + book4times[i].id) === -1) {
                        if (book4times[i].id > 0) {
                            calendarLoading[startDay][j].push('book4time_' + book4times[i].id);
                        }
                    }
                }
                this.courseScheduleTimeSlots['book4time_' + book4times[i].id] = {
                    start: start,
                    end: end,
                };
            }
            calendarLoading = this.sortCalendarLoadingByScheduleStart(calendarLoading);
            this.calendarLoading = calendarLoading;
            let calendar = {};
            for (let i = 0; i < orders.length; i++) {
                let start = moment(orders[i].from);
                let end = moment(orders[i].till);
                let startDay = start.format('YYYY-M-D');
                let startHour = start.hour();
                let endHour = end.hour();
                if (_.isUndefined(calendar[startDay])) {
                    calendar[startDay] = {};
                }
                if (_.isUndefined(calendar[startDay][startHour])) {
                    calendar[startDay][startHour] = {};
                }
                let cardId = orders[i].course_schedule_id;
                if (_.isUndefined(calendar[startDay][startHour][cardId])) {
                    calendar[startDay][startHour][cardId] = this.buildScheduleCardFromOrder(orders[i]);
                }
                calendar[startDay][startHour][cardId] = this.addGuestToCard(calendar[startDay][startHour][cardId], orders[i]);
                let width = 100;
                let offset = 0;
                if (!_.isUndefined(calendarLoading[startDay][startHour])) {
                    if (calendarLoading[startDay][startHour].length > 0) {
                        let max = 1;
                        for (let j = startHour; j <= endHour; j++) {
                            if (!_.isUndefined(calendarLoading[startDay][j])) {
                                if (_.indexOf(calendarLoading[startDay][j], orders[i].course_schedule_id) !== -1) {
                                    if (calendarLoading[startDay][j].length > max) {
                                        max = calendarLoading[startDay][j].length;
                                    }
                                }
                            }
                        }
                        width = 100 / max;
                        offset = _.indexOf(calendarLoading[startDay][startHour], orders[i].course_schedule_id)
                        if (offset < 0) {
                            offset = 0;
                        } else {
                            offset = width * offset;
                        }
                    }
                }
                let height = calendar[startDay][startHour][cardId].duration * 2;
                let top = calendar[startDay][startHour][cardId].from.format('m') * 2;
                calendar[startDay][startHour][cardId].dimensions = {
                    top: top,
                    offset: offset,
                    width: width,
                    height: height
                };
            }


            for (let i = 0; i < waits.length; i++) {
                let start = moment(waits[i].course_schedule.from);
                let end = moment(waits[i].course_schedule.till);
                let startDay = start.format('YYYY-M-D');
                let startHour = start.hour();
                let endHour = end.hour();
                if (_.isUndefined(calendar[startDay])) {
                    calendar[startDay] = {};
                }
                if (_.isUndefined(calendar[startDay][startHour])) {
                    calendar[startDay][startHour] = {};
                }
                let cardId = waits[i].course_schedule.id;
                if (_.isUndefined(calendar[startDay][startHour][cardId])) {
                    calendar[startDay][startHour][cardId] = this.buildScheduleCardFromWait(waits[i]);
                }
                calendar[startDay][startHour][cardId] = this.addGuestToCardFromWait(calendar[startDay][startHour][cardId], waits[i]);
                let width = 100;
                let offset = 0;
                if (!_.isUndefined(calendarLoading[startDay][startHour])) {
                    if (calendarLoading[startDay][startHour].length > 0) {
                        let max = 1;
                        for (let j = startHour; j <= endHour; j++) {
                            if (!_.isUndefined(calendarLoading[startDay][j])) {
                                if (_.indexOf(calendarLoading[startDay][j], waits[i].course_schedule.id) !== -1) {
                                    if (calendarLoading[startDay][j].length > max) {
                                        max = calendarLoading[startDay][j].length;
                                    }
                                }
                            }
                        }
                        width = 100 / max;
                        offset = _.indexOf(calendarLoading[startDay][startHour], waits[i].course_schedule.id)
                        if (offset < 0) {
                            offset = 0;
                        } else {
                            offset = width * offset;
                        }
                    }
                }
                let height = calendar[startDay][startHour][cardId].duration * 2;
                let top = calendar[startDay][startHour][cardId].from.format('m') * 2;
                calendar[startDay][startHour][cardId].dimensions = {
                    top: top,
                    offset: offset,
                    width: width,
                    height: height
                };
            }

            for (let i = 0; i < book4times.length; i++) {
                let start = moment(book4times[i].from);
                let end = moment(book4times[i].till);
                let startDay = start.format('YYYY-M-D');
                let startHour = start.hour();
                let endHour = end.hour();
                if (_.isUndefined(calendar[startDay])) {
                    calendar[startDay] = {};
                }
                if (_.isUndefined(calendar[startDay][startHour])) {
                    calendar[startDay][startHour] = {};
                }
                let cardId = 'book4time_' + book4times[i].id;
                if (_.isUndefined(calendar[startDay][startHour][cardId])) {
                    calendar[startDay][startHour][cardId] = this.buildScheduleCardFromBook4Time(book4times[i]);
                }
                calendar[startDay][startHour][cardId] = this.addGuestToCardFromBook4Time(calendar[startDay][startHour][cardId], book4times[i]);
                let width = 100;
                let offset = 0;
                if (!_.isUndefined(calendarLoading[startDay][startHour])) {
                    if (calendarLoading[startDay][startHour].length > 0) {
                        let max = 1;

                        let cardIdWithoutMinus = cardId.replace('-', '');
                        for (let j = startHour; j <= endHour; j++) {
                            if (!_.isUndefined(calendarLoading[startDay][j])) {
                                if (_.indexOf(calendarLoading[startDay][j], cardIdWithoutMinus) !== -1) {
                                    if (calendarLoading[startDay][j].length > max) {
                                        max = calendarLoading[startDay][j].length;
                                    }
                                }
                            }
                        }
                        width = 100 / max;
                        offset = _.indexOf(calendarLoading[startDay][startHour], cardIdWithoutMinus);
                        if (offset < 0) {
                            offset = 0;
                        } else {
                            offset = width * offset;
                        }
                    }
                }
                let height = calendar[startDay][startHour][cardId].duration * 2;
                let top = calendar[startDay][startHour][cardId].from.format('m') * 2;
                calendar[startDay][startHour][cardId].dimensions = {
                    top: top,
                    offset: offset,
                    width: width,
                    height: height
                };
            }

            this.calendar = calendar;
        },
        buildScheduleCardFromOrder: function (order) {
            let card = _.clone(order);
            delete card.id;
            delete card.user_id;
            card.type = 'order';
            card.from = moment(card.from);
            card.till = moment(card.till);
            let duration = moment.duration(card.till.diff(card.from));
            card.duration = duration.asMinutes();
            card.guests = [];
            return card;
        },
        buildScheduleCardFromWait: function (wait) {
            let card = _.clone(wait);
            delete card.id;
            delete card.user_id;
            card.type = 'wait';
            card.course = _.clone(card.course_schedule.course);
            card.trainer = _.clone(card.course_schedule.trainer);
            card.location = _.clone(card.course_schedule.location);
            card.price = _.clone(card.course_schedule.price);
            card.capacity = _.clone(card.course_schedule.capacity);
            card.booked_by = _.clone(card.author);
            card.link = _.clone(card.course_schedule.link);
            card.from = moment(card.course_schedule.from);
            card.till = moment(card.course_schedule.till);
            let duration = moment.duration(card.till.diff(card.from));
            card.duration = duration.asMinutes();
            card.guests = [];
            delete card.course_schedule;
            delete card.author;
            delete card.booking;
            delete card.created_at;
            delete card.updated_at;
            delete card.user;
            return card;
        },
        nl2br: function (str) {
            return str.replace(/([^>])\n/g, '$1<br/>');
        },

        buildScheduleCardFromBook4Time: function (book4Time) {
            let card = _.clone(book4Time);
            if (card.status === 'Check In') {
                card.type = 'book4time-checkin';
            } else if (card.status === 'Transportation') {
                card.type = 'transportation';
                //card.service_name = this.nl2br(card.service_name);
            } else {
                card.type = 'book4time';
            }
            delete card.id;
            delete card.user_id;
            card.course = card.service_name;
            card.trainer = card.technician_name;
            // card.location = card.location;
            // card.price = card.price;
            card.capacity = null;
            card.booked_by = null;
            card.link = null;
            card.from = moment(card.from);
            card.till = moment(card.till);
            let duration = moment.duration(card.till.diff(card.from));
            card.duration = duration.asMinutes();
            card.guests = [];
            delete card.created_at;
            delete card.updated_at;

            return card;
        },
        addGuestToCard: function (card, order) {
            let guest = {};
            guest.order_id = order.id;
            guest.wait_id = null;
            guest.book4time_id = null;
            guest.user = this.getGuestById(order.user_id);
            let alreadyHasSameOrder = _.find(card.guests, function (v, k) {
                return v.order_id === order.id;
            });
            if (_.isUndefined(alreadyHasSameOrder)) {
                card.guests.push(guest);
            }
            card.type = 'order';
            return card;
        },

        addGuestToCardFromWait: function (card, wait) {
            let guest = {};
            guest.order_id = null;
            guest.book4time_id = null;
            guest.wait_id = wait.id;
            guest.user = this.getGuestById(wait.user_id);
            let alreadyHasSameOrder = _.find(card.guests, function (v, k) {
                return v.wait_id === wait.id;
            });
            if (_.isUndefined(alreadyHasSameOrder)) {
                card.guests.push(guest);
            }
            return card;
        },

        addGuestToCardFromBook4Time: function (card, book4Time) {
            let guest = {};
            guest.order_id = null;
            guest.wait_id = null;
            guest.book4time_id = book4Time.id;
            guest.user = this.getGuestById(book4Time.user_id);
            let b4t = book4Time;
            let alreadyHasSameBook4Time = _.find(card.guests, function (v, k) {
                return v.book4time_id === b4t.id;
            });
            if (_.isUndefined(alreadyHasSameBook4Time)) {
                card.guests.push(guest);
            }
            return card;
        },
        getGuestById: function (user_id) {
            return _.find(this.guests, function (g) {
                return g.id === user_id;
            });
        },
        filterOrders: function () {

        },
        newCourseOrder: function (date, hour) {
            let start = moment(date).set('hour', hour).set('minutes', 0);
            let end = moment(date).set('hour', hour + 1).set('minutes', 0);
            //console.log({from: start.format('h:mm'), till: end.format('h:mm')});
            this.$emit('new-course-order', {from: start, till: end})
        },
        showScheduleDetails: function (courseOrder) {
            if (courseOrder.type === 'book4time') {
                this.$emit('book4time-details', {book4time_id: courseOrder.book4time_id})
            } else {
                this.$emit('schedule-details', {course_schedule_id: courseOrder.course_schedule_id})
            }
        },
        getEventData: function () {
            return {
                courseOrder: this.selectedCourseOrder,
            };
        },
        getCalendarDateName: function (date) {
            let width = this.windowWidth;
            let format = 'dddd, MMMM D';
            if (this.dates.length > 1) {
                if (this.dates.length < 7) {
                    if (width < 600) {
                        format = 'dd';
                    } else if (width < 1200) {
                        format = 'ddd, MMM D';
                    } else {
                        format = 'dddd, MMMM D';
                    }
                } else {
                    if (width < 600) {
                        format = 'MMM, D';
                    } else if (width < 1200) {
                        format = 'MMM, Do';
                    } else {
                        format = 'MMMM, Do';
                    }
                }
            }
            return moment(date).format(format);
        }
    },
    filters: {
        dateFormat: function (date, format) {
            return moment(date).format(format);
        }
    },
    computed: {},
}
</script>
